
import { Component, Vue, Watch, Prop, Inject, InjectReactive } from "vue-property-decorator"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import ScrollTabs from "./ScrollTabs.vue"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar
	}
})
export default class ScrollTab extends Vue {
	@InjectReactive("tabControl") private tabsControl!: ScrollTabs;
	@InjectReactive("activeId") private activeId!: string | null;

	@Prop()
	public title!: string;

	@Prop({ type: Boolean })
	scrollable!: boolean;

	@Prop({ type: Boolean, default: true })
	show!: boolean

	@Prop({ type: String, default: null })
	public tooltip!: boolean

	id: string | null = null;

	@Watch("active")
	onActiveChanged (newVal: boolean) {
		if (newVal) {
			this.$emit("active")
		}
	}

	public get active () {
		return this.activeId !== null && this.activeId === this.id
	}

	mounted () {
		if (this.tabsControl) {
			this.id = this.tabsControl.registerTab(this)
		}
	}

	beforeDestroy () {
		if (this.tabsControl) {
			this.tabsControl.unregisterTab(this)
			this.id = null
		}
	}
}

